import React, { useState } from 'react';
import { Button, TextField, Box, Typography, Paper, CircularProgress } from '@mui/material';
import { functions } from '../config/firebase';
import { httpsCallable } from 'firebase/functions';

const TestVolumeData: React.FC = () => {
  const [symbol, setSymbol] = useState('LCII');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState<any>(null);
  const [error, setError] = useState<string>('');

  const testVolume = async () => {
    setLoading(true);
    setError('');
    setResult(null);
    
    try {
      const testTwelveDataVolume = httpsCallable(functions, 'testTwelveDataVolume');
      const response = await testTwelveDataVolume({ symbol });
      setResult(response.data);
    } catch (err: any) {
      setError(err.message || 'Failed to test volume data');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper sx={{ p: 3, m: 2 }}>
      <Typography variant="h6" gutterBottom>Test Twelve Data Volume</Typography>
      
      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <TextField
          value={symbol}
          onChange={(e) => setSymbol(e.target.value.toUpperCase())}
          label="Symbol"
          size="small"
        />
        <Button 
          variant="contained" 
          onClick={testVolume}
          disabled={loading || !symbol}
        >
          {loading ? <CircularProgress size={24} /> : 'Test Volume'}
        </Button>
      </Box>

      {error && (
        <Typography color="error" sx={{ mb: 2 }}>{error}</Typography>
      )}

      {result && (
        <Box>
          <Typography variant="subtitle2" gutterBottom>Results for {result.symbol}:</Typography>
          
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" fontWeight="bold">Quote Endpoint:</Typography>
            <Typography variant="body2">Volume: {result.quoteEndpoint?.volume}</Typography>
            <Typography variant="body2">Avg Volume: {result.quoteEndpoint?.average_volume}</Typography>
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" fontWeight="bold">Complex Data 1min (OLD Production):</Typography>
            <Typography variant="body2" color="error">Volume: {result.complexData1minEndpoint?.volume} (1-minute only!)</Typography>
            <Typography variant="body2">Avg Volume: {result.complexData1minEndpoint?.average_volume}</Typography>
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" fontWeight="bold">Complex Data 1day (NEW Production):</Typography>
            <Typography variant="body2" color="success.main">Volume: {result.complexData1dayEndpoint?.volume} (daily total)</Typography>
            <Typography variant="body2">Avg Volume: {result.complexData1dayEndpoint?.average_volume}</Typography>
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" fontWeight="bold">Time Series (Last 5 days):</Typography>
            {result.timeSeriesEndpoint?.volumeHistory?.map((day: any, idx: number) => (
              <Typography key={idx} variant="body2">
                {day.datetime}: {day.volume}
              </Typography>
            ))}
          </Box>

          <details>
            <summary>Full Response</summary>
            <pre style={{ fontSize: '0.8em', overflow: 'auto' }}>
              {JSON.stringify(result, null, 2)}
            </pre>
          </details>
        </Box>
      )}
    </Paper>
  );
};

export default TestVolumeData;